import { axios } from "../config";

function getInstitutionAdmins(data) {
  return axios.get("api/v1/institutions/admins", { params: data });
}

function addInstitutionAdmins(data) {
  return axios.post("api/v1/institutions/admins", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

function getAdminPrivileges(params) {
  return axios.get("api/v1/privileges", { params });
}

function deleteInstitutionAdmin(id) {
  return axios.delete(`api/v1/institutions/admins/${id}`);
}

function updateInstitutionAdmins(id, data) {
  return axios.post(`api/v1/institutions/admins/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

function getAdminDetails(id) {
  return axios.get(`api/v1/institutions/admins/details/${id}`);
}

export {
  getInstitutionAdmins,
  addInstitutionAdmins,
  getAdminPrivileges,
  deleteInstitutionAdmin,
  updateInstitutionAdmins,
  getAdminDetails
};
